// a falsy context calls the function without `this`, as a plain call does
export default function apply(func, context, args) {
  return Function.prototype.apply.call(func, context || undefined, args);
}